import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import * as styles from './TrustCarousel.styles';

interface TrustItemProps {
  headerIconURL: string;
  headerText: string;
  heading: string;
  onItemVisible?: (heading: string) => void;
  subHeading: string;
}

export const TrustItem = ({
  headerIconURL,
  headerText,
  heading,
  onItemVisible,
  subHeading,
}: TrustItemProps) => {
  const trustItemRef = useImpressionRef<HTMLLIElement>(() => {
    onItemVisible?.(`${headerText} ${heading}`);
  });

  return (
    <li css={styles.item} ref={trustItemRef}>
      <h4 css={styles.itemHeader}>
        <span>{headerText}</span>
        <img alt="" src={headerIconURL} />
      </h4>
      <h5>{heading}</h5>
      <p>{subHeading}</p>
    </li>
  );
};
